import React, { useEffect, useState } from 'react';
import {
  BodyContainer,
  ModalHeader,
  Title,
  ButtonContainer,
  ModalWrapper,
} from './TrovaPopUp.style';
import { Modal } from '@vfit/shared/atoms';
import { getBodyModalHeight } from './modal.utils';
import { tracking, useTracking } from '@vfit/shared/data-access';

const TrovaModal = (props) => {
  useTracking({ event: ['view'], disableInitialTrack: true });

  const [height, setHeight] = useState(500);
  const {
    data: { title = ' ', instructionsInformation = [] },
    onCloseModal,
    show,
  } = props;
  const event_label = 'popup:snodo-agente-negozio';
  useEffect(() => {
    if (show) {
      setHeight(getBodyModalHeight('body-container'));
      tracking(
        {
          event_name: ['view'],
          page_section: 'eshop',
          page_subsection: 'popup',
          page_type: 'trova agente-negozio',
          event_category: 'sales',
          channel: 'business',
          page_environment: 'Web',
          journey_name: 'trova agente-negozio',
          journey_type: 'journey',
          event_label: event_label,
          page_name: `${window?.utag_data?.page_name}:${event_label}`,
        },
        'view'
      );
    }
  }, [show]);

  return (
    <Modal show={show} height={height} onCloseModal={onCloseModal} isModalFullContainer withBorderRadius >
      <ModalWrapper>
        <BodyContainer id={'body-container'}>
          <ModalHeader dangerouslySetInnerHTML={{ __html: title }} />
          {instructionsInformation?.map((item, index) => {
            const {
              title,
              button: { isBlank = 'true', label = '', link = '' },
            } = item;
            return (
              <React.Fragment key={index}>
                <Title dangerouslySetInnerHTML={{ __html: title }} />
                <ButtonContainer>
                  <div>
                    <a
                      data-name={`find-agent-popup-cta-${index}`}
                      target={isBlank === 'true' ? '_blank' : undefined}
                      href={`${link}?icmp=ebu_web-aziende_popup-agente-negozio`} // Add `icmp` parameter
                      className="modal-link"
                      onClick={() => {
                        // Determine the correct name based on label content
                        const formattedLabel = label.toLowerCase();
                        let mappedValue = 'default'; // Fallback in case no match

                        if (formattedLabel.includes('negozio')) {
                          mappedValue = 'negozio';
                        } else if (
                          formattedLabel.includes('agente') ||
                          formattedLabel.includes('agenzia')
                        ) {
                          mappedValue = 'agenzia';
                        }
                        tracking(
                          {
                            event_name: ['ui_interaction'],
                            event_category: 'users',
                            event_action: 'click',
                            link_name: `${window?.utag_data?.page_name}:${mappedValue}`,
                          },
                          'link'
                        );
                      }}
                    >
                      {label}
                    </a>
                  </div>
                </ButtonContainer>
              </React.Fragment>
            );
          })}
        </BodyContainer>
      </ModalWrapper>
    </Modal>
  );
};

export default TrovaModal;
